import $ from 'jquery';

/** Chart.js external tooltips are appended to document.body and persist after navigation. */
export function hideChartJsTooltip() {
    const tooltipEl = document.getElementById('chartjs-tooltip');
    if (tooltipEl) {
        tooltipEl.style.opacity = '0';
        tooltipEl.style.display = 'none';
    }
}

/** Hide chart tooltips and any jQuery-shown dashboard hover tooltips (common on mobile tap). */
export function hideDashboardChartTooltips() {
    hideChartJsTooltip();
    $('.hover-tooltip').hide();
}
